import React from 'react';
import styles from './styles.module.scss';
import Flex from 'src/components/Flex';
import PageContainer from 'src/components/PageContainer';
import NavBar from '../NavBar';
import PageContent from 'src/components/PageContent';
import Card from 'src/components/Card';
import LoadingIcon from 'src/components/LoadingIcon';
import {
    useSurveyMigrationConfig,
    useSurveyMigrationPreview,
    useSurveyMigrationStatus,
} from 'src/queries/useSurveyMigration';
import ConfigurationSection from './ConfigurationSection';
import PreviewSection from './PreviewSection';
import ProgressSection from './ProgressSection';
import ResultsSection from './ResultsSection';

function SurveyMigration() {
    const { data: config, isLoading, error } = useSurveyMigrationConfig();
    const isReadyForPreview = !!config?.isValidated;
    const { data: job } = useSurveyMigrationStatus(isReadyForPreview);
    const preview = useSurveyMigrationPreview(isReadyForPreview);

    const status = job?.status;
    const showProgress = status === 'IN_PROGRESS' || status === 'PAUSED';
    const showResults = status === 'COMPLETED' || status === 'FAILED';

    return (
        <PageContainer>
            <NavBar />
            <PageContent>
                <Flex self="stretch" align="center" justify="start">
                    <Flex value={1} className={styles.pageTitle}>
                        Survey Migration
                    </Flex>
                </Flex>

                {isLoading ? (
                    <Card className={styles.cardWrap}>
                        <Flex justify="center">
                            <LoadingIcon />
                        </Flex>
                    </Card>
                ) : error ? (
                    <Card className={styles.cardWrap}>
                        <div className={styles.error}>
                            {error instanceof Error ? error.message : 'Failed to load configuration'}
                        </div>
                    </Card>
                ) : (
                    <>
                        <ConfigurationSection config={config ?? null} />

                        {showProgress && job && <ProgressSection job={job} />}
                        {showResults && job && <ResultsSection job={job} />}

                        {isReadyForPreview && !showProgress && !showResults && (
                            <PreviewSection
                                preview={preview.data}
                                isLoading={preview.isLoading}
                                error={preview.error}
                                jobInProgress={false}
                            />
                        )}
                    </>
                )}
            </PageContent>
        </PageContainer>
    );
}

export default SurveyMigration;
